import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import CapsuleButton from 'components/button/CapsuleButton';
import { useTranslation } from 'react-i18next';
/**
 * * 관리자 관리 - 관리자 상세 정보 카드
 */

const ManagerDetailInfoCard = ({ record, onClick }) => {
  const { t } = useTranslation();
  return (
    <Container>
      <div className='box_title'>
        <h3>{t('managerID.header.title')}</h3>
        <CapsuleButton onClick={onClick}>
          {t('managerID.header.updateButton')}
        </CapsuleButton>
      </div>
      <div className='box_info'>
        <div>
          <dl>
            <dt>{t('managerID.header.userName')}</dt>
            <dd>{record?.userName}</dd>
          </dl>
          <dl>
            <dt>{t('managerID.header.userEmail')}</dt>
            <dd>{record?.userEmail}</dd>
          </dl>

          <dl style={{ marginBottom: '0' }}>
            <dt>{t('managerID.header.userOrganization')}</dt>
            <dd>{record?.userOrganization}</dd>
          </dl>
        </div>
        <div>
          {record?.userMaster !== 1 && (
            <>
              <dl>
                <dt>{t('managerID.header.userPlatformName')}</dt>
                <dd>
                  {record?.userPlatform === ''
                    ? 'X'
                    : `${record?.userPlatform_name}`}
                </dd>
              </dl>
              <dl>
                <dt>{t('managerID.header.userManagementName')}</dt>
                <dd>
                  {record?.userManagement === ''
                    ? 'X'
                    : `${record?.userManagement_name}`}
                </dd>
              </dl>
            </>
          )}
          <dl style={{ marginBottom: '0' }}>
            <dt>{t('managerID.header.userMaster')}</dt>
            <dd>{record?.userMaster === 1 ? 'O' : 'X'}</dd>
          </dl>
        </div>
      </div>
    </Container>
  );
};

export default ManagerDetailInfoCard;

const Container = styled.section`
  background-color: #fff;
  padding: 1.2rem 1rem 1.2rem 1.2rem;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  h3 {
    color: ${theme.colors.blueText};
    font-weight: 700;
    font-size: 1.2rem;
    margin-bottom: 1rem;
    margin-left: 0.5rem;
  }
  .box_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .box_info {
    display: flex;

    > div {
      background-color: #fff;
      width: 25vw;
      padding: 1.2rem 0px 1.2rem 1rem;
      border-radius: 0.8rem;
    }
    > div:nth-child(2) {
      margin-left: 2%;
    }
  }
  dl {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    dt,
    dd {
      padding: 5px 5px;
    }
    dt {
      color: ${theme.colors.blueText};
      background-color: ${theme.colors.blue_1};
      font-weight: 600;
      width: 150px;
      text-align: center;
      border-radius: 3px;
      margin-right: 20px;
    }
  }
`;
